import type { PlanData } from './dealCalculations'
import { isGalaxyPlanLabel } from './planCatalogCore'

/** Não inventa "Plano de Marketing" quando o plano e o escopo não são de marketing. */
export function visibleProjectTypeLabel(planName: string, projectType?: string | null): string {
  const label = String(projectType || '').trim()
  if (!label) return ''
  const genericMarketing = label.toLowerCase() === 'plano de marketing'
  const namedMarketing = planName.toLowerCase().includes('marketing')
  if (genericMarketing && !namedMarketing) return ''
  return label
}

/** Rótulo do bloco 3 — alinhado ao Proposal Studio (SlidePreview). */
export function getSlideProjectTypeLabel(plan: PlanData): string {
  if (isGalaxyPlanLabel(plan.nome)) return ''

  const name = plan.nome || ''
  const explicit = visibleProjectTypeLabel(name, plan.projectType)
  if (explicit) return explicit

  const commerce = String(plan.itemTipo || '').toLowerCase()
  if (commerce === 'servico') return 'Projeto Fechado'
  if (commerce === 'avulso') return 'Projeto Avulso'

  const tipo = plan.tipo?.trim() || ''
  if (!tipo || tipo === 'plano' || tipo === 'servico' || tipo === 'avulso') return ''
  return visibleProjectTypeLabel(name, tipo)
}
